import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import SubValuationModal from '../../../../Modals/SubValuation'
import NotesModal from '../../../../Modals/Notes'

import Header from './Components/Header'
import Table from './Components/Table'

const SubValuations = props => {

  const {
    subValuationModal,
    notesModal,
    componentDidMount,
    onCloseSubValuationModal,
    onCloseNotesModal,
  } = props

  useEffect(() => {
    componentDidMount()
  }, [])

  return (

    <React.Fragment>

      <Header />

      <Table />

      {subValuationModal.show && (
        <SubValuationModal
          {...subValuationModal}
          onClose={onCloseSubValuationModal}
        />
      )}

      {notesModal.show && (
        <NotesModal
          {...notesModal}
          onClose={onCloseNotesModal}
        />
      )}

    </React.Fragment>

  )

}

SubValuations.propTypes = {
  subValuationModal: PropTypes.object.isRequired,
  componentDidMount: PropTypes.func.isRequired,
  onCloseSubValuationModal: PropTypes.func.isRequired,
}

export default SubValuations
